var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullScreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,32C14.3,32,0,46.3,0,64v96c0,17.7,14.3,32,32,32s32-14.3,32-32V96h64c17.7,0,32-14.3,32-32s-14.3-32-32-32H32z M64,352 c0-17.7-14.3-32-32-32S0,334.3,0,352v96c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32s-14.3-32-32-32H64V352z M320,32 c-17.7,0-32,14.3-32,32s14.3,32,32,32h64v64c0,17.7,14.3,32,32,32s32-14.3,32-32V64c0-17.7-14.3-32-32-32H320z M448,352 c0-17.7-14.3-32-32-32s-32,14.3-32,32v64h-64c-17.7,0-32,14.3-32,32s14.3,32,32,32h96c17.7,0,32-14.3,32-32V352z M295.2,376.3H152.8 c-27.1,0-49.1-22-49.1-49.1V184.8c0-27.1,22-49.1,49.1-49.1h142.3c27.1,0,49.1,22,49.1,49.1v142.3 C344.3,354.3,322.3,376.3,295.2,376.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullScreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FullScreen.8fa8d5126cab559d3147530e015f1608.svg";